import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { useFormState, useWatch } from 'react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { useUser } from 'src/Hooks/useUser'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { checkTrueRecursively } from 'src/Libs/flow/utils'
import { Select } from 'src/Libs/inputs/react-hook-form'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

export const WiringTopology: React.FC = () => {
  const { t } = useCustomTranslation()
  const { userData } = useUser()

  const isAdmin = userData?.level === 'EXT_SERVICE_PLUS'
  const isUserLevelUser = userData?.level === 'USER'
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  const enableEdit = (canEdit || isAdmin) && !isUserLevelUser

  const { control } = useInstallationForm()
  const { dirtyFields } = useFormState({ control, name: 'storageSystem.generalSettings.wiringTopologyDeviceId' })

  const isDirty = checkTrueRecursively(dirtyFields.storageSystem?.generalSettings?.wiringTopologyDeviceId)

  const wiringTopologyDeviceId = useWatch({ control, name: 'storageSystem.generalSettings.wiringTopologyDeviceId' })
  const storages = useWatch({ control, name: 'storageDevices' })
  const emcDevice = useWatch({ control, name: 'emcDevice' })

  return (
    <>
      <Typography variant="h2" mb={2}>
        {t('installation.configOverview.wiringMode')}
      </Typography>
      {emcDevice && (
        <SettingsBox
          title={t(`installation.wiringMode.title`)}
          description={t(`installation.wiringMode.${wiringTopologyDeviceId?.toString() === emcDevice.deviceId ? 'parallel' : 'serial'}`)}
          suffix={
            <Select
              name="storageSystem.generalSettings.wiringTopologyDeviceId"
              options={[
                {
                  label: emcDevice.name,
                  value: emcDevice.deviceId,
                  disabled: !enableEdit,
                },
                ...storages.map(item => ({
                  label: item.name,
                  value: item.deviceId,
                  disabled: !enableEdit,
                })),
              ]}
            />
          }
        />
      )}
      {isDirty && (
        <Box pt={1} pr={2} mb={1} fontWeight={'bold'}>
          <Box component={'span'} color={theme => theme.palette.primary.main}>
            {t('installation.configOverview.wiring-change-title')}
          </Box>
          <Box component={'span'} pl={1}>
            {t('installation.configOverview.wiring-change-info')}
          </Box>
        </Box>
      )}
    </>
  )
}
